<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
                <dxi-item itemType="group">
                    <dxi-item dataField="paymentId" editorType="dxNumberBox" [label]="{ text: 'Payment Id' }"></dxi-item>
                    <dxi-item
                        dataField="dealerId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Dealer' }"
                        [editorOptions]="{ items: dealers, displayExpr: 'displayName', valueExpr: 'id' }"
                    ></dxi-item>
                    <dxi-item dataField="orderNumber" editorType="dxNumberBox" [label]="{ text: 'Order #' }"></dxi-item>
                    <dxi-item dataField="invoiceNumber" editorType="dxNumberBox" [label]="{ text: 'Invoice #' }"></dxi-item>
                    <dxi-item dataField="referenceNumber" [label]="{ text: 'Reference #' }"></dxi-item>
                    <dxi-item
                        dataField="methodId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Method' }"
                        [editorOptions]="{ items: paymentMethods, displayExpr: 'name', valueExpr: 'id' }"
                    ></dxi-item>
                    <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                    <dxi-item dataField="paymentStart" editorType="dxDateBox" [label]="{ text: 'Payment From' }"></dxi-item>
                    <dxi-item dataField="paymentEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                    <dxi-item dataField="readyToExportStart" editorType="dxDateBox" [label]="{ text: 'Ready to Export From' }"></dxi-item>
                    <dxi-item dataField="readyToExportEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                    <dxi-item dataField="exportedStart" editorType="dxDateBox" [label]="{ text: 'Exported From' }"></dxi-item>
                    <dxi-item dataField="exportedEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-end align-items-center mt-3">
                <div *ngIf="payments" class="me-3">{{ payments.length }} {{ payments.length === 1 ? 'item found' : 'items found' }}</div>
                <button accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button (click)="clear()" class="btn btn-light ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div *ngIf="payments" class="m-1 grid-fill">
        <dx-data-grid
            #dataGrid
            [dataSource]="payments"
            keyExpr="id"
            [columnAutoWidth]="false"
            [wordWrapEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onExporting)="onExporting($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
        >
            <dxi-column dataField="id" width="90"></dxi-column>
            <dxi-column dataField="salesOrderList" caption="SalesOrders" width="125"></dxi-column>
            <dxi-column dataField="invoiceList" caption="Invoices" width="125"></dxi-column>
            <dxi-column dataField="paymentDate" dataType="date" format="shortDate" width="125"></dxi-column>
            <dxi-column dataField="dealerDisplayName" caption="Dealer" width="300"></dxi-column>
            <dxi-column dataField="referenceNumber" caption="Reference #" width="200"></dxi-column>
            <dxi-column dataField="total" dataType="number" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-column>
            <dxi-column dataField="paymentMethodName" caption="Method" width="150"></dxi-column>
            <dxi-column dataField="notes" width="300"></dxi-column>
            <dxi-column dataField="readyToExport" dataType="date" format="shortDate" width="125"></dxi-column>
            <dxi-column dataField="quickBooksId" caption="QB Id" width="125"></dxi-column>
            <dxi-column dataField="quickBooksLastExport" caption="Exported" dataType="date" format="shortDate" width="125"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="payment-history-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    class="btn btn-sm btn-success"
                >
                    Open
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="payments" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
